import { Prescriber } from './prescriber';

export interface Slot {
	id: string;
	prescriber: Prescriber;
	availabilityCareSkillId: number;
	weekDay: number;
	date: Date;
	startTime: number;
	endTime: number;
	status: string;
	meetingLink: string;
	missionRequestId: number;
}

export interface WeekSlots {
	day: string;
	date: string;
	slots: Slot[];
}

export enum SlotStatus {
	INITIAL,
	REGISTERED,
	ASSIGNED,
	COMPLETED
}
